export default __webpack_public_path__ + "static/media/Quality-Policy.41564a52.jpg";